import React from "react";
import { Input, Row, Col } from "reactstrap";
import axios from "axios";
import { connect } from "react-redux";
import config from "react-global-configuration";
import consoleFunction from "../../../../Helpers";
import "../../../../config";
import getDateTimeField from "../../../../Utils";

const authApi = config.get("apiDomain");

class AddUnitgrp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      UnitgroupName: "",
      Unitgroupnameborder: "1px solid #dee2e6",
      isButtonDisabled: false,
    };
  }

  Formvalidation = () => {
    if (this.state.UnitgroupName !== "") {
      this.setState({
        Unitgroupnameborder: "1px solid #dee2e6",
        isButtonDisabled: true,
      });
      this.Addunitgrp();
    } else {
      this.setState({
        Unitgroupnameborder: "1px solid #fb6340",
      });
    }
  };

  Addunitgrp = () => {
    if (this.state.id === "") {
      let datetime_field = getDateTimeField();
      axios({
        method: "post",
        url: `${authApi}unittype/`,
        headers: {
          "content-type": "application/json",
          Authorization: `token ${this.props.token}`,
        },
        data: {
          unitname: this.state.UnitgroupName,
          createdby: this.props.username,
          createdat: datetime_field,
          modifiedby: this.props.username,
          modifiedat: datetime_field,
        },
      })
        .then((res) => {
          if (res.status) {
            this.props.closebtn();
            this.props.callbackfunction();
          }
        })
        .catch((err) => {
          consoleFunction(
            " Stockgroup name creation error",
            err.response.request.response
          );
          this.setState({ error: err.message });
        });
    }
  };

  handleUnitgroupName = (event) => {
    this.setState({
      UnitgroupName: event.target.value.replace(/[^\w\s]/gi, ""),
    });
  };

  render() {
    return (
      <React.Fragment>
        <button className="x" onClick={this.props.closebtn}>
          x
        </button>
        <div className="header">Add Unit Type</div>
        <div className="Scroll-Content">
          <Row>
            <Col md="6">
              <label className="form-control-label">Name</label>
              <Input
                type="text"
                className="form-control-alternative"
                defaultValue={this.state.UnitgroupName}
                style={{ border: this.state.Unitgroupnameborder }}
                onChange={this.handleUnitgroupName}
                placeholder="enter unit type"
              />
              {this.state.Unitgroupnameborder !== "1px solid #dee2e6" ? (
                <h5 style={{ color: "#fb6340" }}>Please Enter Unit Type</h5>
              ) : null}
            </Col>
            <Col md="6">
              <div className="button">
                <button
                  id="buttonsave"
                  className="btn btn-dark"
                  style={{ float: "right", marginRight: 15 }}
                  onClick={this.Formvalidation}
                  disabled={this.state.isButtonDisabled}
                >
                  Add
                </button>
              </div>
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    token: state.token,
  };
};
export default connect(mapStateToProps, null)(AddUnitgrp);
